import { render, staticRenderFns } from "./helpDetail.vue?vue&type=template&id=74cb5ab8&scoped=true&"
import script from "./helpDetail.vue?vue&type=script&lang=js&"
export * from "./helpDetail.vue?vue&type=script&lang=js&"
import style0 from "./helpDetail.vue?vue&type=style&index=0&id=74cb5ab8&prod&lang=less&"
import style1 from "./helpDetail.vue?vue&type=style&index=1&id=74cb5ab8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cb5ab8",
  null
  
)

export default component.exports